var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 12,
    viewBox: "0 0 25 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.35,
    x: 0.833252,
    y: 0.833374,
    width: 21,
    height: 10.3333,
    rx: 2.16667,
    stroke: "#0D0D0D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M23.3333 4.00006V8.00006C24.138 7.66128 24.6613 6.87319 24.6613 6.00006C24.6613 5.12693 24.138 4.33884 23.3333 4.00006Z",
    fill: "#0D0D0D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.33325,
    y: 2.33337,
    width: 18,
    height: 7.33333,
    rx: 1.33333,
    fill: "#0D0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/Battery.e47ce7013c040e5cb28a8cca6aa03f7e.svg";
export { ForwardRef as ReactComponent };